// test969
(969 && 0);
